<template>
	<svg version="1.1" id="Layer_1"
		 xmlns="http://www.w3.org/2000/svg"
		 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		 width="20px" height="20px" viewBox="0 0 20 20"
		 style="enable-background:new 0 0 20 20;"
		 xml:space="preserve">
															<path class="st0" fill="#FFFFFF"
																  d="M1.5,0C0.671,0,0,0.671,0,1.5S0.671,3,1.5,3C10.047,3,17,9.953,17,18.5c0,0.828,0.672,1.5,1.5,1.5 s1.5-0.672,1.5-1.5C20,8.299,11.701,0,1.5,0z"/>
		<path class="st0" fill="#FFFFFF"
			  d="M1.5,8C0.671,8,0,8.671,0,9.5S0.671,11,1.5,11C5.636,11,9,14.364,9,18.5c0,0.828,0.671,1.5,1.5,1.5 s1.5-0.672,1.5-1.5C12,12.71,7.29,8,1.5,8z"/>
		<circle class="st0" fill="#FFFFFF" cx="2" cy="18" r="2"/>
														</svg>
</template>

<script>
    export default {}
</script>